import React, { useEffect, useState } from 'react'
import { Skeleton } from 'antd'
import API from 'API';
import TermHandle from '../UniversitySide/UniversityTerms/TermHandle';
import dayjs from "dayjs";
import { useAuth } from 'AuthContext';
import StudentDashboard from './StudentDashboard';
import TeacherDashboard from './TeacherDashboard';

const NOW = dayjs();

export default function Dashboard() {
    const [terms, setTerms] = useState(null);
    const [selectedTerm, setSelecterdTerm] = useState(null);
    const [loading, setLoading] = useState(true);
    const { user } = useAuth();
    useEffect(() => {
        async function getData() {
            try {
                const response = await API.get("/student/terms/", {
                    params: {
                        page_size: 1000
                    }
                });
                var check = false;
                for (const r of response.data.results) {
                    r.start_time = dayjs(r.start_time);
                    r.end_time = dayjs(r.end_time);
                    if (!check) {
                        if (r.start_time.isBefore(NOW) && r.end_time.isAfter(NOW)) {
                            check = true;
                            setSelecterdTerm(r);
                        }
                    }
                }
                if (!check) {
                    setSelecterdTerm(response.data.results[0] || null);
                }
                setTerms(response.data.results);
                setLoading(false);
            } catch (e) {
                console.log(e);
            } finally {

            }
        }
        getData();
    }, [])
    return loading ? <Skeleton active /> : <>
        <h5>Chọn kỳ:</h5>
        <TermHandle terms={terms} setTerms={setTerms} edit={false}
            selectedTerm={selectedTerm} setSelecterdTerm={setSelecterdTerm} />
        {user.role !== 100 ?  <TeacherDashboard selectedTerm={selectedTerm}/>
        : <StudentDashboard selectedTerm={selectedTerm}/>}
    </>
}
